// js/animations.js

document.addEventListener('DOMContentLoaded', function () {

    // ? => Register ScrollTrigger
    gsap.registerPlugin(ScrollTrigger)

    // ? => Utilisation de Lenis smooth scroll
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    })

    // ? =>Connecter Lenis avec GSAP
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)

    // ? => Animation des titres des pages Réalisations archives et single (textes avec rotation)
    document.querySelectorAll('.hs-title-1').forEach(function (title) {
        const split = new SplitType(title, { types: 'words, chars' })


        split.chars.forEach(function (char) {
            const wrapper = document.createElement('span')
            wrapper.style.cssText = 'display:inline-block; vertical-align:bottom;'
            char.parentNode.insertBefore(wrapper, char)
            wrapper.appendChild(char)
        })

        gsap.from(split.chars, {
            y: '40%',
            rotation: 10,
            opacity: 0,
            delay: 0.4,
            duration: 0.8,
            ease: 'power3.out',
            stagger: 0.02,        // faster stagger on chars than words
            transformOrigin: 'bottom left',
            scrollTrigger: {
                trigger: title,
                start: 'top 85%',
                toggleActions: 'play none none none',
            },
        })
    })


    // ? => ANimations des chiffres et du "White Board"
    gsap.set('.white-board', { opacity: 0, y: 30 })
    gsap.set('.white-board .is-mini-square', { opacity: 0, y: 20, scale: 0.95 })
    document.querySelectorAll('.count-up strong, .count-up b').forEach(function (el) {
        el.dataset.value = el.textContent.trim().replace(/\s/g, '')
        el.textContent = '0' // 👈 ça ne touche qu'au strong/b, pas aux unités autour
        gsap.set(el.closest('.count-up'), { opacity: 0 })
    })
    ScrollTrigger.create({
        trigger: '.white-board',
        start: 'top 80%',
        once: true,

        onEnter: function () {
            const tl = gsap.timeline()

            // 1. Whiteboard fade up
            tl.to('.white-board', {
                opacity: 1,
                y: 0,
                duration: 0.9,
                ease: 'power3.out',
            })

            // 2. Squares tous en même temps
            tl.to('.white-board .is-mini-square', {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 0.8,
                ease: 'back.out(1.7)',
                // stagger: 0.08,
            }, '-=0.3')

            tl.add(() => {
                document.querySelectorAll('.count-up strong, .count-up b').forEach(function (el, index) {
                    const target = parseFloat(el.dataset.value) // 👈 ici, plus el.textContent
                    if (isNaN(target)) return

                    const decimals = target % 1 !== 0 ? 1 : 0
                    function formatNumber(val) {
                        return val.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0')
                    }

                    gsap.set(el.closest('.count-up'), { opacity: 1 })
                    gsap.to({ val: 0 }, {
                        val: target,
                        delay: index * 0.1,
                        duration: 2,
                        ease: 'power2.out',
                        onUpdate: function () {
                            el.textContent = formatNumber(this.targets()[0].val)
                        },
                    })
                })
            }, '-=0.3')
        },
    })
    // ? END COUNT UP



    // ✅ Fade up elements
    // gsap.utils.toArray('.animate-fade-up').forEach(function (el) {
    //     gsap.from(el, {
    //         y: 20,
    //         opacity: 0,
    //         duration: 0.9,
    //         ease: 'power3.out',
    //         scrollTrigger: {
    //             trigger: el,
    //             start: 'top 88%',
    //             toggleActions: 'play none none none',
    //         },
    //     })
    // })

    // gsap.utils.toArray('.anim-fade-up').forEach(function (el) {
    //     gsap.from(el, {
    //         y: 10,
    //         opacity: 0,
    //         duration: 1,
    //         delay:0.4,
    //         ease: 'power3.out',
    //         scrollTrigger: {
    //             trigger: el,
    //             start: 'top 88%',
    //         }
    //     })
    // })

    // ? => ANimation des "cards" de réalisations sur les pages Archives Réalisations //
    gsap.utils.toArray('.anim-fade-up-children, .cards-anim').forEach(function (parent) {
        const children = Array.from(parent.children)

        const placeholders = children.map(el => {
            // Get size BEFORE hiding
            const rect = el.getBoundingClientRect()

            const placeholder = document.createElement('div')
            placeholder.classList.add('placeholder')
            placeholder.style.cssText = `
            width: 0px;
            height: ${rect.height}px;
            display: inline-block;
        `
            el.parentNode.insertBefore(placeholder, el)

            // Hide AFTER measuring
            el.style.display = 'none'

            return { placeholder, finalWidth: rect.width }
        })

        gsap.to(placeholders.map(p => p.placeholder), {
            width: (i) => placeholders[i].finalWidth,
            duration: 0.9,
            delay: 0.5,
            ease: "expo.out",
            stagger: 0,
            scrollTrigger: {
                trigger: parent,
                start: 'top 80%',
            },
            onComplete: function () {
                children.forEach((el, i) => {
                    setTimeout(() => {
                        placeholders[i].placeholder.remove()
                        el.style.display = ''
                        // Animate AFTER element is visible
                        gsap.from(el, {
                            y: 5,
                            opacity: 0,
                            delay: 0.1,
                            duration: 0.8,
                            ease: 'power3.out',
                        })
                    }, i * 0)
                })
            }
        })
    })



    // => Creation de fonctions réutilisables //

    // ? => animHeight — 0 vers hauteur naturelle
    // * animHeight — clip-path + opacity
    function animHeight(el, options = {}) {
        gsap.set(el, { clipPath: 'inset(0 0 100% 0)', opacity: 0 })
        return gsap.to(el, {
            clipPath: 'inset(0 0 0% 0)',
            opacity: 1,
            duration: 0.9,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            ...options,
        })
    }

    // * animFromLeft — fade in depuis la gauche
    function animFromLeft(el, options = {}) {
        return gsap.from(el, {
            x: -40,
            opacity: 0,
            duration: 0.9,
            ease: 'power3.out',
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            ...options,
        })
    }

    // ? => pour l'animation des titres (les titres par défaut avec texte en gras bleu)
    function animTitle(title, options = {}) {
        const split = new SplitType(title, { types: 'lines' })
        split.lines.forEach(line => {
            const wrapper = document.createElement('span')
            wrapper.style.cssText = 'display:block; '
            line.parentNode.insertBefore(wrapper, line)
            wrapper.appendChild(line)
        })

        // * strong — coloration en parallèle
        const strong = title.querySelector('strong')
        if (strong) {
            const finalColor = getComputedStyle(strong).color
            gsap.set(strong, { color: getComputedStyle(title).color })
            gsap.to(strong, {
                color: finalColor,
                duration: 0.6,
                ease: 'power2.out',
                delay: 0.7,
                ...options.scrollTrigger ? { scrollTrigger: options.scrollTrigger } : {},
            })
        }

        return gsap.from(split.lines, {
            y: '30%',
            opacity: 0,
            duration: 1,
            ease: 'power3.out',
            stagger: 0.2,
            ...options,
        })
    }

    // ? => FADE UP 1
    function animFadeUp(el, options = {}) {
        return gsap.from(el, {
            y: 20,
            opacity: 0,
            duration: 0.9,
            ease: 'power3.out',
            ...options,
        })
    }
    // ? => FADE UP 2
    function animFadeUpSlow(el, options = {}) {
        return gsap.from(el, {
            y: 10,
            opacity: 0,
            duration: 1,
            delay: 0.4,
            ease: 'power3.out',
            ...options,
        })
    }


    // ? => TITRE AVEC entrée en rotation
    function animChars(title, options = {}) {
        const split = new SplitType(title, { types: 'words,chars' })
        split.chars.forEach(char => {
            const wrapper = document.createElement('span')
            wrapper.style.cssText = 'display:inline-block; vertical-align:bottom;'
            char.parentNode.insertBefore(wrapper, char)
            wrapper.appendChild(char)
        })
        return gsap.from(split.chars, {
            y: '40%',
            rotation: 10,
            opacity: 0,
            delay: 0.4,
            duration: 0.8,
            ease: 'power3.out',
            stagger: 0.02,
            transformOrigin: 'bottom left',
            ...options,
        })
    }



    // ==/





    // ==> Utilisation des fonctions en stand alone avec scrolltrigger =>

    //ANImHEIGHT
    gsap.utils.toArray('.anim-height').forEach(el => {
        animHeight(el)
    })


    // animTitle
    gsap.utils.toArray('.anim-title, .is-style-df-title').forEach(title => {
        animTitle(title, {
            scrollTrigger: {
                trigger: title,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        })
    })

    // animFadeUp — version rapide
    gsap.utils.toArray('.animate-fade-up, .fade-up').forEach(el => {
        animFadeUp(el, {
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        })
    })

    // animFadeUp — version slow (on override les defaults)
    gsap.utils.toArray('.anim-fade-up').forEach(el => {
        animFadeUp(el, {
            y: 10,
            duration: 1,
            delay: 0.4,
            scrollTrigger: {
                trigger: el,
                start: 'top 80%',
            },
        })
    })


    gsap.utils.toArray('.hs-title-1').forEach(title => {
        animChars(title, {
            scrollTrigger: {
                trigger: title,
                start: 'top 85%',
                toggleActions: 'play none none none',
            },
        })
    })


    // =====================
    // Utilisation des focntions dans une timeline
    // =====================

    // const titleEl = document.querySelector('.anim-hero-title')
    // const fadeEl  = document.querySelector('.anim-fade-up')
    // const cardEl  = document.querySelector('.animate-fade-up')

    // const tl = gsap.timeline({ delay: 0.3 })

    // tl.to(hero, { opacity: 1, scale: 1, duration: 1.1, ease: 'power3.out' })

    //   // animTitle — injecté après le hero
    //   .add(animTitle(titleEl), '-=0.5')

    //   // animFadeUp rapide — après le titre
    //   .add(animFadeUp(cardEl), '-=0.3')

    //   // animFadeUp slow — après le card
    //   .add(animFadeUp(fadeEl, { y: 10, duration: 1, delay: 0.2 }), '-=0.3')

    // // gsap.fromTo("#main-header", 
    // //   { y: 0, opacity: 0 },
    // //   { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" }
    // // );
    // // Boutons — fade up + scale
    // gsap.utils.toArray('.entry-content  .wp-block-button').forEach(btn => {
    //     gsap.from(btn, {
    //         y: 15,
    //         // opacity: 0,
    //         // scale: 0.95,
    //         duration: 0.5,
    //         scrollTrigger: {
    //             trigger: btn,
    //             start: 'top 88%',
    //         }
    //     })
    // })





    // gsap.utils.toArray('.is-style-df-title strong').forEach(strong => {
    //     const title = strong.closest('[class*="anim-title"], h1, h2, h3')

    //     // Get the final color from CSS
    //     const finalColor = getComputedStyle(strong).color

    //     // Start same color as parent
    //     gsap.set(strong, { color: getComputedStyle(title).color })

    //     // Animate to accent color after title reveals
    //     gsap.to(strong, {
    //         color: finalColor,
    //         duration: 0.6,
    //         ease: 'power2.out',
    //         delay: 0.9, // after title anim
    //         scrollTrigger: {
    //             trigger: title,
    //             start: 'top 88%',
    //         }
    //     })
    // })


    // --> GSAP TIMELINES !!

    document.fonts.ready.then(() => {
        const hero = document.querySelector('.is-style-spotlight')
        const content = document.querySelector('.df-landing-content')
        if (!hero || !content) return

        const title = content.querySelector('.anim-hero-title')
        const els = Array.from(content.querySelectorAll('.anim-fade-up'))
            .filter(el => !el.closest('.wp-block-button') && !el.matches('.wp-block-button'))
        const btns = Array.from(content.querySelectorAll('.wp-block-button'))

        gsap.set(hero, { opacity: 0, scale: 1.05 })
        gsap.set(els, { opacity: 0, y: 20 })
        gsap.set(btns, { opacity: 0, y: 15, scale: 0.95 })
        if (title) gsap.set(title, { opacity: 0 })

        const tl = gsap.timeline({ delay: 0.3 })

        // 1. Background image
        tl.to(hero, {
            opacity: 1,
            scale: 1,
            duration: 1.1,
            ease: 'power3.out',
        })
        // 1b. ::before overlay — apparaît juste après le bg
        tl.fromTo(hero,
            { '--before-op': 0.2, '--before-w': '50%' },
            { '--before-op': 1, '--before-w': '100%', duration: 1.5, ease: 'power2.out' },
            '-=0.9'
        )
        // 2. Title — chars left to right
        if (title) {
            gsap.set(title, { opacity: 1 })
            const split = new SplitType(title, { types: 'words,chars' })

            // Wrap each word to prevent breaking
            split.words.forEach(word => {
                word.style.cssText = 'display:inline-block;'
            })

            split.chars.forEach(char => {
                const wrapper = document.createElement('span')
                wrapper.style.cssText = 'display:inline-block; overflow:hidden; vertical-align:bottom;'
                char.parentNode.insertBefore(wrapper, char)
                wrapper.appendChild(char)
            })

            gsap.set(split.chars, { x: -40, opacity: 0 })
            tl.to(split.chars, {
                x: 0,
                opacity: 1,
                duration: 0.8,
                ease: 'power3.out',
                stagger: { each: 0.03, from: 'start' },
            }, '-=0.7')

            const strong = title.querySelector('strong')
            if (strong) {
                const finalColor = getComputedStyle(strong).color
                gsap.set(strong, { color: getComputedStyle(title).color })
                tl.to(strong, {
                    color: finalColor,
                    duration: 0.6,
                    ease: 'power2.out',
                }, '-=0.2')
            }
        }

        // 3. Éléments fade-up
        if (els.length) {
            tl.to(els, {
                y: 0,
                opacity: 1,
                duration: 0.9,
                ease: 'power3.out',
                stagger: 0.15,
            }, '-=0.5')
        }

        // 4. Boutons
        if (btns.length) {
            tl.to(btns, {
                y: 0,
                opacity: 1,
                scale: 1,
                duration: 0.7,
                ease: 'back.out(1.7)',
                stagger: 0.1,
            }, '-=0.5')
        }
    })



    // Split les chars
    document.querySelectorAll(".is-style-offset-title-block").forEach((block) => {
        const heading = block.querySelector(".wp-block-heading");
        //   const split = new SplitText(heading, { type: "chars" });
        const split = new SplitText(heading, {
            type: "words,chars",
            wordsClass: "word",
            charsClass: "char"
        });
        const siblings = Array.from(block.children).filter(el => !el.classList.contains("wp-block-heading"));

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: block,
                start: "top 80%",
            }
        });

        // 1. Le bloc parent
        tl.fromTo(block,
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" }
        )
            // 2. Le heading (bg + chars)
            .fromTo(heading,
                { opacity: 0 },
                { opacity: 1, duration: 0.3, ease: "power2.out" }, "-=0.4"
            )
            .from(split.chars, {
                opacity: 0,
                x: -15,
                duration: 0.3,
                ease: "power2.out",
                stagger: 0.03,
            }, "-=0.2")
            // 3. Les autres éléments (p, div, ul...)
            .fromTo(siblings,
                { opacity: 0, y: 10 },
                { opacity: 1, y: 0, duration: 0.5, ease: "power2.out", stagger: 0.1 }
                , "-=0.2");
    });


    // --> TIMELINE DF CTA =>
    const ctaSection = document.querySelector('.anim-block')
    gsap.utils.toArray('.anim-block').forEach(section => {

        const title = section.querySelector('.play')
        const fadeEls = gsap.utils.toArray(section.querySelectorAll('.chain'))

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 85%',
                toggleActions: 'play none none none',
            }
        })

        // * 1. Titre
        if (title) {
            tl.add(animTitle(title, { delay: 0 }))
        }

        // * 2. Fade-up en chaîne
        if (fadeEls.length) {
            fadeEls.forEach((el, i) => {
                tl.add(animFadeUp(el, { delay: 0 }), i === 0 ? '-=0.4' : '-=0.6')
            })
        }

    })




    // = TIMELINE — grow puis fade in from left en chaîne
    const section = document.querySelector('.anim-block-2')
    if (section) {
        const growEl = section.querySelector('.anim-height, .starter')
        const leftEls = gsap.utils.toArray(section.querySelectorAll('.anim-from-left, .chain'))

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 85%',
                toggleActions: 'play none none none',
            }
        })

        // * 1. grow
        if (growEl) {
            tl.add(animHeight(growEl, { scrollTrigger: undefined }))
        }

        // * 2. fade in from left en chaîne
        if (leftEls.length) {
            leftEls.forEach((el, i) => {
                tl.add(animFromLeft(el, { scrollTrigger: undefined }), i === 0 ? '-=0.4' : '-=0.7')
            })
        }
    }

    // ARROW LIST, horizontal anim
    gsap.utils.toArray('.anim-arrow-list, .is-style-circle-arrow-list').forEach(list => {

        const items = gsap.utils.toArray(list.querySelectorAll('li, .anim-item'))

        gsap.from(items, {
            x: -30,
            opacity: 0,
            duration: 0.6,
            delay: 0.4,
            ease: 'power3.out',
            stagger: {
                each: 0.12,
                from: 'start', // ? gauche à droite
            },
            scrollTrigger: {
                trigger: list,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        })

    })



})